import React from "react"
import Cabecalho from "../Cabecalho"
import { ConfiguracaoFiscalForm } from "./components/ConfiguracaoFiscalForm"

export function ConfiguracaoFiscal() {
    return (
        <>
            <Cabecalho pagina="Configuração Fiscal" />
            <ConfiguracaoFiscalForm />
        </>
    )
}
